import { RootState } from '@/App/store';

export const selectUserDeleteOpen = (state: RootState) => state.user.deleteOpen;
